import React, { useState, useEffect } from 'react';
import RelationShip_data from './Relationship_data';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faL, faBars, faXmark, faUser, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';
import { Button, Row, Col, Container, Dropdown, Form, ListGroup, Modal, Table } from 'react-bootstrap';
import { Buffer } from 'buffer';
import './DynamicScreen.css';
import { format } from 'date-fns'; // Make sure to import the 'format' function
import { act } from 'react-dom/test-utils';




const DynamicScreen = (props) => {
  const [schemaList, setSchemaList] = useState([]);
  const [schemaList_SA, setSchemaList_SA] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState('');
  const [isSchemaSelected, setIsSchemaSelected] = useState(false);
  const [istableRestrictionClick, setIstableRestrictionClick] = useState(false);
  const [selectedJobApplication, setSelectedJobApplication] = useState(false);
  const [allTables, setAllTables] = useState([]);
  const [NewTables, setNewTables] = useState([]);
  const [tables, setTables] = useState([]);
  const [tablesType, setTablesType] = useState([]);
  const [tableForPermission, setTableForPermission] = useState([]);
  const [rulesTabledata, setRulesTabledata] = useState([]);
  const [tableComment, setTableComment] = useState('');
  const [nonRestrictedTables, setNonRestrictedTables] = useState([]);
  const [viewRestrictionTables, setViewRestrictionTable] = useState([]);
  const [newViewRestrictionTable, setNewViewRestrictionTable] = useState([]);
  const [othersTable, setOthersTable] = useState([]);
  const [tablesForRestriction, setTablesforRestriction] = useState([]);
  const [roleTablesData, setRoleTablesData] = useState([]);
  const [userTablesData, setUserTableData] = useState([]);
  const [permissionTableData, setPermissionTableData] = useState([]);
  const [detailDependencyTable, setDetailDependencyTable] = useState('');
  const [searchText, setSearchText] = useState('');

  const [executeInputValues, setExecuteInputValues] = useState([]);
  const [newColumns, setNewColumns] = useState([]);

  const [isEditclick, setIsEditClick] = useState(false);
  const [isRolefieldclick, setRoleFieldClick] = useState(true);
  const [isUsermanagementChosen, setIsUsermanagementChosen] = useState(false);
  const [isPermissionTableChosen, setIsPermissionTableChosen] = useState(false);
  const [permissionData, setPermissionData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [roleFormData, setRoleFormData] = useState([]);
  const [insertPermissionData, setinsertPermissionData] = useState([]);

  const [dataForRestrictioncondition, setDataForRestrictioncondition] = useState([]);
  const [editRestrictionDataArray, setEditRestrictionDataArray] = useState([]);
  const [retrievedRoleData, setretrievedRoleData] = useState([]);
  const [retrivedRoleDatakeys, setRetrivedRoleDatakeys] = useState([]);
  const [retrivedRoleDatavalues, setRetrivedRoleDatavalues] = useState([]);
  const [retrievedPermissionData, setretrievedPermissionData] = useState([]);
  const [tableRestrictionData, setTableRestrictionData] = useState([]);
  const [isEditTableRestrictionClicked, setIsEditTableRestrictionClicked] = useState(false);
  const [CheckedState, setCheckedState] = useState();
  const [editRestrictionTable, setEditRestrictionTable] = useState([]);
  const [restrictionSubmitButton, setRestrictionSubmitButton] = useState('SUBMIT');
  const [isEditPermissionClick, SetIsEditPermissionClick] = useState(false);
  const [selectedPermissionId, setSelectedPermissionId] = useState();
  const [userInput, setUserInput] = useState([]);
  const [userEditData, setUserEditData] = useState([]);
  const [isEditUserclick, setIsEditUserclick] = useState(false);
  const [passError, setPassError] = useState('');
  const [isRulesMatch, setIsRulesMatch] = useState(false);
  const [isFileIn, setIsFileIn] = useState(false);
  const [hasExternalLinks, setHasExternalLinks] = useState(true);
  const [hasStoredProcedure, setHasStoredProcedure] = useState(true);
  const [hasTablePermissions, setHasTablePermissions] = useState(true);
  const [hasOtherTables, setHasOtherTables] = useState(true);




  const [showAddRowbutton, setShowAddRowbutton] = useState(false);

  const [showAddbutton, setShowAddbutton] = useState(true);
  const [showEditbutton, setShowEditbutton] = useState(true);
  const [showDeletebutton, setShowDeletebutton] = useState(true);
  const [showViewbutton, setShowViewbutton] = useState(true);
  const [showsubmitButton, setShowsubmitButton] = useState(true);


  const [submitButton, setSubmitButton] = useState('SUBMIT');
  const [retrievedData, setRetrievedData] = useState([]);
  const [selectedFile, setSelectedFile] = useState();
  const [selectedId, setSelectedId] = useState();
  const [storedProcedureData, setStoredProcedureData] = useState([]);
  const [ruleTableMatch, setRuleTableMatch] = useState([]);

  const [extLinks, setExtLinks] = useState([]);
  const [arrayofExternalLinks, setArrayofExternalLinks] = useState([]);
  const [executeMenu, setExecuteMenu] = useState([]);
  const [arrayofExecutables, setArrayofExecutables] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [fields, setFields] = useState([]);
  const [jobFields, setJobFields] = useState([]);
  const [defaultFields, setDefaultFields] = useState([]);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [data, setData] = useState([]);
  const [tableLength, setTableLength] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [isRestrictionModalOpen, setIsRestrictionModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isEditPermissionModalOpen, setIsEditPermissionModalOpen] = useState(false);
  const [isExitJobModalOpen, setIsExitJobModalOpen] = useState(false);
  const [relationshipOptionsList, setRelationshipOptionsList] = useState([]);

  const [goToPageInput, setGoToPageInput] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [delId, setDelId] = useState("");

  const [order, setOrder] = useState("ASC");
  const [currentSortcolumn, setCurrentSortcolumn] = useState();
  const [arrowButton, setArrowButton] = useState("");

  const [isTableDropdownOpen, setIsTableDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isExecuteDropdownOpen, setIsExecuteDropdownOpen] = useState(false);
  const [isOtherTableDropdownOpen, setIsOtherTableDropdownOpen] = useState(false);
  const [isConfigDropdownOpen, setIsConfigDropdownOpen] = useState(false);
  const [isRelationDropdownOpen, setIsRelationDropdownOpen] = useState(false);
  const [isjobDropdownOpen, setIsjobDropdownOpen] = useState(false);
  const [isExitJobDropdownOpen, setIsExitJobDropdownOpen] = useState(false);
  const [isOtherDropdownOpen, setIsOtherDropdownOpen] = useState(false);
  const [isAccountDropDownOpen, setIsAccountDropDownOpen] = useState(false);

  const [selectedLink, setSelectedLink] = useState('');
  const [showIframe, setShowIframe] = useState(false);
  const [showExecuteModal, setShowExecuteModal] = useState(false);
  const [showProcedureDataModal, setShowProcedureDataModal] = useState(false);
  const [showRelationScreen, setShowRelationScreen] = useState(false);
  const [procedureName, setProcedureName] = useState('');
  const [showExecuteButton, setShowExecuteButton] = useState(false);
  const [procedureParameters, setProcedureParameters] = useState([]);
  const [showSideBar, setShowSideBar] = useState(true);

  const [search, setSearch] = useState("");
  const history = useHistory();

  const [companyDetails, setCompanyDetails] = useState([]);
  const [imgBlob, setImgBlob] = useState('');

  const [formData, setFormData] = useState([]);

  const [dependencyAddButtons, setDependencyAddButtons] = useState([]);


  const [crudaccessData, setCrudAccessData] = useState([]);

  // Retrieve the selected company name from the route parameters
  const companyName = props.location.state && props.location.state.companyName;
  const userName = props.location.state && props.location.state.userName;
  const roleCode = props.location.state && props.location.state.roleCode;
  const permissionTables = props.location.state && props.location.state.permissionTables;
  const crudPermissionData = props.location.state && props.location.state.crudPermissionData;


  console.log('crud permissions', crudPermissionData);

  //column sorting function
  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...data].sort((a, b) =>
        a[col] > b[col] ? 1 : -1
      );
      setData(sorted);
      setCurrentSortcolumn(col);
      setArrowButton("▲");
      setOrder("DSC");

    }
    if (order === "DSC") {
      const sorted = [...data].sort((a, b) =>
        a[col] < b[col] ? 1 : -1
      );
      setData(sorted);
      setCurrentSortcolumn(col);
      setArrowButton("▼");
      setOrder("ASC");
    }
  };


  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Number of items to display per page
  const [totalPages, setTotalPages] = useState('');

  const formatDates = async (selected, newItemsperPage) => {
    debugger;
    const page = 0 + (selected === undefined ? 0 : selected);
    const checkItemsPerpage = 0 + (newItemsperPage === undefined ? 10 : newItemsperPage);
    const columns1 = fields.map((column) => column.column_name);
    console.log('page number', fields);
    console.log('search text', searchText);

    try {
      let search = 'null';
      if (searchText != '') {
        search = searchText;
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getForTables/${selectedSchema}/${selectedTable}/${page * checkItemsPerpage}/${checkItemsPerpage}/${columns1}/${search}`);
      const formatType = 'yyyy-MM-dd HH:mm';
      const newArray = response.data.map(item => {
        const newItem = { ...item };

        fields.forEach(column => {
          if (newItem.hasOwnProperty(column.column_name) && (column.data_type === 'datetime' || column.data_type === 'date')) {
            const originalDate = new Date(newItem[column.column_name]);

            // Use the 'format' function from date-fns
            const formattedDate = format(originalDate, formatType);
            newItem[column.column_name] = formattedDate;
          }
        });

        return newItem;
      });

      console.log('sdsdsd', newArray);
      console.log('data for retrieved data', newArray);

      setData(newArray);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    //console.log('page number', selected);
    console.log('page fields', fields);
    formatDates(selected, itemsPerPage);

  };

  const handleSearch = async (searchText) => {
    debugger;
    setSearchText(searchText);
    const columns = fields.map((column) => column.column_name);

    if (searchText === "") {
      getTableDataLength(selectedTable);
      formatDates();
    } else {
      try {
        getTableDataLength1(selectedTable, searchText);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getSearchedValue/${selectedSchema}/${selectedTable}/${columns}/${searchText}`);
        console.log('searched values', response.data);
        setData(response.data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  /*   const openInNewTab = (url, id) => {
      // Open the URL in a new tab or window
      const newWindow = window.open(url, '_blank');
  
      // Navigate to the 'Job Application' page in the existing window
      if (newWindow) {
        newWindow.opener = null; // Avoid security issues with cross-origin navigation
        window.location.href = `/jobApplication/${id}`;
      }
    }; */

  const openInNewTab = (id) => {

    const currentOrigin = window.location.origin;

    if (!id) {
      window.open(`${currentOrigin}/jobApplication`, '_blank');
    }
    else {

      window.open(`${currentOrigin}/jobApplication?id=${id}`, '_blank');
    }

  };

  const openInJobExitTab = (id) => {

    const currentOrigin = window.location.origin;
    //window.open(`${currentOrigin}/JobExitForm`, '_blank');

    if (!id) {
      window.open(`${currentOrigin}/JobExitForm`, '_blank');
    }
    else {

      window.open(`${currentOrigin}/JobExitForm?id=${id}`, '_blank');
    }

  };


  // Go to page function
  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber - 1);
      setGoToPageInput('');
    } else {
      // Show an error message or handle invalid input
      console.log("invalid page number");
    }
  };

  // Function to handle entries per page change
  const handleEntriesPerPageChange = (e) => {
    const newEntriesPerPage = parseInt(e.target.value, 10);
    setItemsPerPage(newEntriesPerPage);
    setCurrentPage(0); // Reset to the first page when changing entries per page
    formatDates(currentPage, newEntriesPerPage);

  };


  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  console.log('page index', startIndex);
  //const itemsToDisplay = data.slice(startIndex, endIndex);
  //function to handle filtered data for searching
  const filteredData = data.filter((item) =>
    Object.values(item).some(
      (value) =>
        value && value.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  console.log(filteredData);

  //slice filtered data
  /* const itemsToDisplay = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
 */
  //Get schemas
  const loadDatabase = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + 'api/getDatabases');
      setSchemaList(response.data);
      console.log("schemas", response.data);
    } catch (error) {
      console.error('Error loading schema:', error);
    }
  };

  const loadDatabaseSA = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + 'api/getDatabases_SA');
      setSchemaList_SA(response.data);
    } catch (error) {
      console.error('Error loading schema:', error);
    }
  };


  /*   const handleSchemaChange = (schemaName) => {
      setSelectedSchema(schemaName);
      loadTables(schemaName);
      setSelectedTable(''); // Clear the selected table when changing the schema
    }; */



  const loadTables = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getTables/${schemaName}`);

      const tablesArray = response.data;

      const viewTable = await loadNewViewRestrictionTable(schemaName);


      const newTables = tablesArray.map((item) => ({
        TableComment: item.TABLE_COMMENT,
        Tables: item.Tables,
        haveId: item.haveId,
        type: 'T'
      }));

      console.log('newTables', newTables);
      setTablesType(newTables);

      const loadedOtherTable = await loadTableOthers(schemaName);

      const othersTable = loadedOtherTable.map((item) => ({
        Tables: item.name,
        Require_newTab: item.req_new_tab,
        type: 'OT'
      }));

      console.log('others table', othersTable);

      const loadedExecuteMenu = await loadExecuteMenu(schemaName);

      const loadedExternalLinks = await loadExternalLinks(schemaName);

      setExtLinks(loadedExternalLinks);


      const extLinksArray = loadedExternalLinks.map((item) => item.menu);
      const arrayofExternalLinks = extLinksArray.map((item) => ({
        TableComment: '',
        Tables: item,
        haveId: 1,
        type: 'EL'
      }));


      const newFilteredAddedTables = newTables.filter((table) => {
        return crudPermissionData.some((item) => item.table === table.Tables && item.read === 1);
      });


      if (roleCode === 'SA' || roleCode === 'AD') {

        const addedTables = [...newTables, ...arrayofExternalLinks, ...loadedExecuteMenu, ...othersTable];

        setTableForPermission(addedTables);

        console.log('added tables', addedTables);


        if (roleCode !== 'SA') {
          const activeViewTables = viewTable.filter((table) => table.is_active === '1');

          const onlyActiveTables = activeViewTables.map((table) => ({
            Tables: table.tables
          }));

          const filterAddedTables = addedTables.filter((item) => {
            // Check if the tables property of the item is present in onlyActiveTables
            return onlyActiveTables.some((table) => table.Tables === item.Tables);
          });


          setNewTables(filterAddedTables);
        } else {
          setNewTables(addedTables);
        }

        const onlyTables = addedTables.map((item) => ({ Tables: item.Tables, type: item.type }));

        const prevData = [];
        const tableswithCondition = onlyTables.map((item) => ({
          ...prevData,
          [item.Tables]: {
            ...prevData[item.Tables],
            ['remove']: false, ['type']: item.type
          },
        }));


        setDataForRestrictioncondition(tableswithCondition);

        console.log('tables with condition', tableswithCondition);


      } else {

        const ExtLinkFilter = arrayofExternalLinks.filter((item) => {
          return crudPermissionData.some((permission) => permission.table === item.Tables && permission.read === 1);
        });

        if (ExtLinkFilter.length === 0) {
          setHasExternalLinks(false);
        } else {
          setHasExternalLinks(true);
        }

        const ExecuteFilter = loadedExecuteMenu.filter((item) => {
          return crudPermissionData.some((permission) => permission.table === item.Tables && permission.read === 1);
        });

        if (ExecuteFilter.length === 0) {
          setHasStoredProcedure(false);
        } else {
          setHasStoredProcedure(true);
        }

        if (newFilteredAddedTables.length === 0) {
          setHasTablePermissions(false);
        } else {
          setHasTablePermissions(true);
        }

        const OthersTableFilter = othersTable.filter((item) => {
          return crudPermissionData.some((permission) => permission.table === item.Tables && permission.read === 1);
        });

        if (OthersTableFilter.length === 0) {
          setHasOtherTables(false);
        } else {
          setHasOtherTables(true);
        }


        const addedTables = [...newFilteredAddedTables, ...ExtLinkFilter, ...ExecuteFilter, ...OthersTableFilter];

      

        console.log('otherAdded tables', addedTables);

        if (roleCode !== 'SA') {
          const activeViewTables = viewTable.filter((table) => table.is_active === '1');

          const onlyActiveTables = activeViewTables.map((table) => ({
            Tables: table.tables
          }));

          const filterAddedTables = addedTables.filter((item) => {
            // Check if the tables property of the item is present in onlyActiveTables
            return onlyActiveTables.some((table) => table.Tables === item.Tables);
          });


          setNewTables(filterAddedTables);
        } else {
          setNewTables(addedTables);
        }

        const onlyTables = addedTables.map((item) => ({ Tables: item.Tables, type: item.type }));

        const prevData = [];
        const tableswithCondition = onlyTables.map((item) => ({
          ...prevData,
          [item.Tables]: {
            ...prevData[item.Tables],
            ['remove']: false, ['type']: item.type
          },
        }));


        setDataForRestrictioncondition(tableswithCondition);

      }

      setTablesforRestriction(tablesArray);


      const RoleTables = Object.values(tablesArray).filter(item => item.Tables === 'role');

      setRoleTablesData(RoleTables);

      const PermissionTables = Object.values(tablesArray).filter(item => item.Tables === 'permission');

      setPermissionTableData(PermissionTables);


      const userTablesData = Object.values(tablesArray).filter(item => item.Tables === 'user');

      setUserTableData(userTablesData);

      const filteredArray = tablesArray.filter(item => permissionTables.includes(item.Tables));
      setAllTables(filteredArray);


      const newFilteredArray = filteredArray.filter(item => !(item.Tables === 'role' || item.Tables === 'user' || item.Tables === 'permission'));

      // Find the 'detail_dependency' table in the array
      const detailTable = filteredArray.find(table => table.Tables === 'detail_dependency');

      // Check if the table is found
      if (detailTable) {
        // Access the table details
        setDetailDependencyTable(detailTable.Tables);
        //console.log("detail table", detailTable.Tables)
      } else {
        console.log('detail dependency table not found');
      }
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  const getTableComment = async (tableName) => {
    debugger;
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getTableComments/${selectedSchema}/${tableName}`);
      setTableComment(response.data[0].table_comment);
      console.log("table comment", response.data[0].table_comment);

    } catch (error) {
      console.error('Error loading comments:', error);
    }
  };

  const loadRulesTable = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getRulesTable/${schemaName}`);
      setRulesTabledata(response.data);
      console.log("rules table", response.data);

    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  const loadNonRestrictedTables = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getNonRestrictedTables/${schemaName}`);
      setNonRestrictedTables(response.data);
      console.log('non restricted tables', response.data);
      const nonRestrictedData = response.data;
      setTables(response.data);


      const commonValues = NewTables.filter(item1 =>
        nonRestrictedData.some(item2 => item1.Tables === item2.Tables)
      );

      console.log('common values', commonValues, NewTables);

      const tablesWithTypeT = response.data.filter(item => item.Type === "T");

      //setTablesType(tablesWithTypeT);



    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  const loadViewRestrictionTable = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getViewRestrictionTable/${schemaName}`);
      setViewRestrictionTable(response.data);


    } catch (error) {
      console.error('Error loading table');
    }
  };

  const loadNewViewRestrictionTable = async (schemaName) => {
    try {
      // Wait for the getViewRestrictionTable API call to complete
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getViewRestrictionTable/${schemaName}`);
      setNewViewRestrictionTable(response.data);
      // Return the data to be used in loadTables
      return response.data;
    } catch (error) {
      console.error('Error loading view restriction table:', error);
      // Ensure to handle errors or return a default value
      return null;
    }
  };


  const loadTableOthers = async (schemaName) => {
    try {

      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getTableOthers/${schemaName}`);
      setOthersTable(response.data);
      // Return the data to be used in loadTables
      return response.data;
    } catch (error) {
      console.error('Error loading others table:', error);
      // Ensure to handle errors or return a default value
      return null;
    }
  };

  const loadExternalLinks = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getExternalLinks/${schemaName}`);
      setExtLinks(response.data);
      console.log('ext links', response.data);
      const extLinksArray = response.data.map((item) => item.menu);
      const arrayofExternalLinks = extLinksArray.map((item) => ({
        Tables: item,
        haveId: 1,
        type: 'EL'
      }));
      setArrayofExternalLinks(arrayofExternalLinks);
      return response.data; // Return the array of external links
    } catch (error) {
      console.error('Error getting External links table', error);
      // Handle the error or return an empty array if needed
      return [];
    }
  };


  const loadExecuteMenu = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getExecutableTables/${schemaName}`);
      console.log(response.data);
      setExecuteMenu(response.data);

      const executableArray = response.data.map((item) => item.name);
      console.log("execute tables", executableArray);
      const newExecutablesArray = executableArray.map((item) => ({
        TableComment: '',
        Tables: item,
        haveId: 1,
        type: 'E'
      }));
      setArrayofExecutables(newExecutablesArray);
      return newExecutablesArray;

    } catch (error) {
      console.error('Error getting execute menu');
    }
  };

  //Get Company details and image
  const loadCompanyDetails = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getCompanyDetails/${schemaName}`);
      setCompanyDetails(response.data);
      const imageBuffer = response.data[0].company_logo.data;
      const base64Data = Buffer.from(imageBuffer).toString('base64');
      const decodedData = atob(base64Data);//Decode the base64 converted string using atob.
      setImgBlob(decodedData);


    } catch (error) {
      console.error('Error loading schema:', error);
    }
  };


  const handleTableChange = (tableName) => {
    setShowRelationScreen(false);
    getTableComment(tableName);
    getTableDataLength(tableName);
    setShowExecuteButton(false);
    setShowProcedureDataModal(false);
    setIstableRestrictionClick(false);
    setIsUsermanagementChosen(false);
    setShowIframe(false);
    setSelectedTable(tableName);
    const ruleTablematch = rulesTabledata.filter((item) => item.table_name === tableName);
    console.log('ruletable match', ruleTableMatch);
    if (ruleTablematch.length >= 1) {
      setIsRulesMatch(true);
      setRuleTableMatch(ruleTablematch[0]);
    } else {
      setIsRulesMatch(false);
    }
    console.log("permissions", crudPermissionData);
    const crudaccessData = crudPermissionData.filter(item => item.table === tableName);

    setCrudAccessData(crudaccessData);
    loadFields(tableName);
    //loadDataForTable();
    const crudTables = crudPermissionData.map((item) => item.table);
    if (crudTables.includes(tableName)) {
      handleButtonPermissions(crudaccessData);
    } else {

      setShowAddbutton(true);

      setShowEditbutton(true);

      setShowDeletebutton(true);

      setShowViewbutton(true);

    }

    setIsPermissionTableChosen(false);

    /* if (tableName === 'role') {
      setIsSuperAdmin(true);
    } else {
      setIsSuperAdmin(false);
    }
 */
  };

  const handleChoosePermission = (tableName) => {
    setShowExecuteButton(false);
    setShowProcedureDataModal(false);
    setShowIframe(false);
    setSelectedTable(tableName);
    setIsPermissionTableChosen(true);
    setIstableRestrictionClick(false);
    setIsUsermanagementChosen(false);
    loadRoleTable();
  };

  const handleSelectUserManagement = (tableName) => {
    setShowExecuteButton(false);
    setShowProcedureDataModal(false);
    setShowIframe(false);
    setShowRelationScreen(false);
    setIsUsermanagementChosen(true);
    setIsPermissionTableChosen(false);
    loadUserTable();
    loadRoleTable();
  };

  const handleButtonPermissions = (crudData) => {
    
    const create = crudData[0].create;
    const read = crudData[0].read;
    const update = crudData[0].update;
    const delete_ = crudData[0].delete;

    if (create === 0) {
      setShowAddbutton(false);
    } else {
      setShowAddbutton(true);
    }

    if (update === 0) {
      setShowEditbutton(false);
    } else {
      setShowEditbutton(true);
    }

    if (delete_ === 0) {
      setShowDeletebutton(false);
    } else {
      setShowDeletebutton(true);
    }

    if (read === 0) {
      setShowViewbutton(false);
    } else {
      setShowViewbutton(true);
    }


  };

  const loadpermissions = async (tableName) => {

    try {
      var userEmail = localStorage.getItem('loginEmail');
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `api/getpermissions/${userEmail}/${selectedSchema}/${tableName}`
      );
      console.log('permissions new', response.data);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };



  //Function to get table column fields
  const loadFields = async (tableName) => {
    try {
      debugger;
      loadpermissions(tableName);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/getFields/${selectedSchema}/${tableName}`
      );

      // Assuming fields is an array of objects and you want to concatenate with the new data


      setFields(response.data);
      setDefaultFields(response.data);
      console.log("new fields", response.data);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  //Load fields for job application
  const loadFieldsJobApplication = async () => {
    try {
      // loadpermissions(tableName);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/getJobApplication`
      );
      // Assuming fields is an array of objects and you want to concatenate with the new data


      setJobFields(response.data);
      //setDefaultFields(response.data);
      console.log("Job fields", response.data);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  const loadPermissionTable = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getPermissionTable/${selectedSchema}/${id}`);
      setPermissionData(response.data);
      console.log("Permission table data", response.data);
    } catch (error) {
      console.log('Error loading role table', error);
    }

  };

  const loadRoleTable = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getRoleTable/${selectedSchema}`);
      setRoleData(response.data);
      console.log("role:", response.data, selectedSchema);
    } catch (error) {
      console.log('Error loading role table', error);
    }
  };

  const loadUserTable = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getUserTable/${selectedSchema}`);
      setUserData(response.data);
      console.log("user:", response.data);
    } catch (error) {
      console.log('Error loading role table', error);
    }

  };




  const loadDataForTable = async () => {
    debugger;
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getForTables/${selectedSchema}/${selectedTable}`);
      const formatType = 'yyyy-MM-dd HH:mm';
      const newArray = response.data.map(item => {
        const newItem = { ...item };

        fields.forEach(column => {
          if (newItem.hasOwnProperty(column.column_name) && (column.data_type === 'datetime' || column.data_type === 'date')) {
            const originalDate = new Date(newItem[column.column_name]);

            // Use the 'format' function from date-fns

            const formattedDate = format(originalDate, formatType);
            newItem[column.column_name] = formattedDate;
          }
        });

        return newItem;
      });



      setData(newArray);
      console.log('datas', response.data);
      //setTotalPages(Math.ceil(response.data.length / itemsPerPage));
    } catch (error) {
      console.error(error);
    }
  };

  const getTableDataLength = async (tableName) => {
    try {

      const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getTableLength/${selectedSchema}/${tableName}`);
      console.log('table length', Object.values(response.data[0])[0]);
      setTableLength(Object.values(response.data[0])[0]);
    } catch (error) {
      console.log('error geting table length', error);
    }
  };

  const getTableDataLength1 = async (tableName, searchText1) => {
    try {

      const columns1 = fields.map((column) => column.column_name);
      let search = 'null';
      if (searchText1 != '') {
        search = searchText1;
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getTableLength1/${selectedSchema}/${tableName}/${columns1}/${search}`);
      console.log('table length', Object.values(response.data[0])[0]);
      setTableLength(Object.values(response.data[0])[0]);
    } catch (error) {
      console.log('error geting table length', error);
    }
  };

  const editApplication = () => {

  };


  //Add button for role
  const handlePermissionAddButtonclick = () => {
    setIsPermissionModalOpen(true);
    SetIsEditPermissionClick(false);
  };

  const handleUserAddButtonclick = () => {
    setUserEditData([]);
    setIsUserModalOpen(true);
    setIsEditUserclick(false);
  };

  const handleUserInput = (name, value) => {

    if (isEditUserclick) {
      setUserEditData({
        ...userEditData,
        [name]: value,
      });
    } else {

      setUserInput({
        ...userInput,
        [name]: value,
      });
    }
  };


  const editUser = (id) => {
    setIsEditUserclick(true);
    const userIdMatch = userData.filter(item => item.id === id);
    setUserEditData(userIdMatch[0]);
    console.log(userIdMatch[0]);
    setIsUserModalOpen(true);

  };

  const handleUserSubmit = async () => {
    debugger;
    console.log(userInput);
    console.log(userEditData);
    const UpdatedroleId = roleData.filter(item => item.Rolename === userEditData.Rolename);
    const InsertroleId = roleData.filter(item => item.Rolename === userInput.Rolename);

    console.log("edit role ", UpdatedroleId[0]);

    if (userInput.confirmpassword !== userInput.password) {
      setPassError({
        ...passError,
        confirmPassword: "Password and confirm password should be the same",
      });
      return;
    } else {
      if (!isEditUserclick) {
        try {
          const response = await axios.post(
            process.env.REACT_APP_API_URL + 'api/insertUserData',
            {
              database: selectedSchema,
              Username: userInput.username,
              email: userInput.email,
              password: userInput.confirmpassword,
              ContactNo: userInput.contact_no,
              roleId: InsertroleId[0].id,

            }
          );

          // Check if there's an error property in the response data
          if (response.data && response.data.error) {
            // Display error toast for data already exists
            toast.error(response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          } else {
            // Display success toast
            loadUserTable();
            handleCloseModal();

            loadRoleTable();
            toast.success(response.data.message || 'Data inserted successfully', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        } catch (error) {
          console.error(error);
          toast.error('Error occurred while sending data.', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      } else {
        try {
          const response = await axios.post(
            process.env.REACT_APP_API_URL + 'api/UpdateUserData',
            {
              database: selectedSchema,
              Username: userInput.username,
              email: userInput.email,
              password: userInput.confirmpassword,
              ContactNo: userInput.contact_no,
              roleId: userInput.Rolename,
              EditUsername: userEditData.username,
              EditEmail: userEditData.email,
              EditContactNo: userEditData.contact_no,
              EditRoleId: UpdatedroleId[0].id,
              EditUserId: userEditData.id,
              isEditClick: isEditUserclick
            }
          );

          // Check if there's an error property in the response data
          if (response.data && response.data.error) {
            // Display error toast for data already exists
            toast.error(response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          } else {
            // Display success toast
            handleCloseModal();
            loadUserTable();
            loadRoleTable();
            toast.success(response.data.message || 'Data inserted successfully', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        } catch (error) {
          console.error(error);
          toast.error('Error occurred while sending data.', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      }
    }
  };


  const handleAddrestrictionButtonClick = () => {
    setRestrictionSubmitButton('SUBMIT');
    setIsRestrictionModalOpen(true);
    setIsEditTableRestrictionClicked(false);
  };

  //function to get the entered role data
  const handleAddRolechange = (key, value) => {
    debugger;
    if (key === 'Rolename') {
      const editId = roleData.filter((item) => item.Rolename === value);
      if (editId.length > 0) {
        console.log("role", roleData);
        // console.log('role id', editId[0].id);
        const newValue = editId[0].id;
        editRole(newValue, "E");
      }

    }

    setRoleFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));

  };


  //function to edit the entered role data 
  const handleEditRolechange = (key, index, value) => {


    const newArray = [...retrievedRoleData];

    // Step 2: Locate the object and update the property
    const updatedObject = { ...newArray[index], [key]: value };

    // Step 3: Update the array with the modified object
    newArray[index] = updatedObject;

    console.log(newArray);
    setretrievedRoleData(newArray);

  };

  const handleSelectRole = (role) => {
    console.log(role.target.value);
  };

  const handleCheckboxChange = (tableName, operation) => {
    setinsertPermissionData((prevPermissions) => ({
      ...prevPermissions,
      [tableName]: {
        ...prevPermissions[tableName],
        [operation]: !prevPermissions[tableName]?.[operation]
      }
    }));
  };

  const handleEditPermissionCheckboxChange = (tableName, operation) => {
    console.log('edit perm', retrievedPermissionData);

    const isTableExists = retrievedPermissionData.some((item) => item.table === tableName);

    if (isTableExists) {
      setretrievedPermissionData((prevPermissions) => {
        const updatedPermissions = prevPermissions.map((permission) => {
          if (permission.table === tableName) {
            return {
              ...permission,
              [operation]: permission[operation] === 1 ? 0 : 1,
            };
          }
          return permission;
        });

        return updatedPermissions;
      });
    } else {
      // If the table does not exist, add it to the permissions array
      setretrievedPermissionData((prevPermissions) => [
        ...prevPermissions,
        {
          table: tableName,
          create: 0,
          read: 0,
          update: 0,
          delete: 0,
          [operation]: 1,
        },
      ]);
    }
  };





  //Function to insert role data
  const handleAddPermissionSubmit = async () => {
    debugger;
    console.log("permission data", insertPermissionData);
    console.log("Edit permission data", retrievedPermissionData);
    console.log('exist form data', roleFormData);

    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + 'api/insertRoleandPermissionData', {
        database: selectedSchema,
        Rolecolumns: Object.keys(roleFormData),
        Rolevalues: Object.values(roleFormData),
        EditroleColumns: retrivedRoleDatakeys,
        EditroleValues: retrivedRoleDatavalues,
        username: userName,
        PermissionData: insertPermissionData,
        EditPermissionData: retrievedPermissionData,
        editClick: isEditPermissionClick,
        PermissionId: selectedPermissionId
      });

      formatDates();
      handleCloseModal();

      if (response.data.error) {
        // Display error toast for data already exists
        toast.error(response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        // Display success toast
        formatDates();
        handleCloseModal();
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error('Error occurred while sending data.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const handleRestrictionCheckboxChange = (index) => {
    //debugger;
    setDataForRestrictioncondition((prevData) => {
      const updatedData = [...prevData];
      const tableName = Object.keys(updatedData[index])[0];
      updatedData[index][tableName].remove = true;
      return updatedData;
    });
  };

  const handleEditRestrictionCheckboxChange = (index, tableName, table, CheckedState) => {
    const newDataArray = {
      id: table[tableName].id,
      checkedState: CheckedState
    };

    setEditRestrictionDataArray(newDataArray);
    console.log(newDataArray);


  };


  //function to Add restriction data
  const handleAddRestrictionSubmit = async () => {
    console.log("permission data", dataForRestrictioncondition);

    if (restrictionSubmitButton === 'SUBMIT') {
      try {
        const response = await axios.post(process.env.REACT_APP_API_URL + 'api/insertRestrictionData', {
          database: selectedSchema,
          username: userName,
          PermissionData: dataForRestrictioncondition
        });


        setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
        setColumns(Array(fields.length).fill('')); // Assuming you have an initial state for `columns`
        formatDates();
        handleCloseModal();

        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } catch (error) {

        console.error(error);
        toast.error('Error occurred while sending data.', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } else {
      try {
        const response = await axios.post(process.env.REACT_APP_API_URL + 'api/updateRestrictionData', {
          database: selectedSchema,
          username: userName,
          UpdatedPermissionData: editRestrictionDataArray
        });


        setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
        setColumns(Array(fields.length).fill('')); // Assuming you have an initial state for `columns`
        formatDates();
        handleCloseModal();

        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } catch (error) {

        console.error(error);
        toast.error('Error occurred while sending data.', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }

  };


  //Add button to open modal
  const handleAddButtonClick = () => {
    loadRelationDetails(selectedTable);
    setShowsubmitButton(true);
    setRetrievedData([]);
    setSubmitButton('SUBMIT');
    setIsModalOpen(true);
    setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
    setColumns(Array(fields.length).fill('')); // Assuming you have an initial state for `columns`

    //console.log(fields);
    const allColumns = fields.map((column) => column.COLUMN_NAME);
    setColumns(allColumns);
    setNewColumns(allColumns);
    console.log("all columns", allColumns);

  };


  const loadRelationDetails = async (tableName) => {
    debugger;
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getRelationshipDetails/${selectedSchema}/${tableName}`);
      fetchAllFieldRelations(response.data);
      console.log("relationShipDetails", response.data);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };



  const loadPrimaryDataList = async (tableName, value, text) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/getPrimaryDataList/${selectedSchema}/${tableName}/${value}/${text}`
      );
      return response.data;
    } catch (error) {
      console.error('Error loading tables:', error);
      return null;
    }
  };



  const fetchAllFieldRelations = async (relationShipDetails) => {
    if (relationShipDetails && relationShipDetails.length > 0) {
      const optionsList = [];

      for (const field of relationShipDetails) {
        const primaryTableDataList = await loadPrimaryDataList(field.primary_table, field.Primary_Table_Value, field.Primary_Table_Text);
        const insideDataList = [];
        if (primaryTableDataList && primaryTableDataList.length > 0) {

          primaryTableDataList.forEach((fieldInside) => {
            const dataInside = {
              value: fieldInside.value,
              text: fieldInside.text,
            };
            insideDataList.push(dataInside);
          });
          const dataOption = {
            column: field.Relation_Table_value,
            dependency: field.Dependency_Value,
            options: insideDataList,
          };

          optionsList.push(dataOption);
        }
      }

      //console.log('optionsList', optionsList);
      setRelationshipOptionsList(optionsList);
      console.log("relationshipOptionlist", relationshipOptionsList);


    }
  };


  const handleCloseModal = () => {
    setDependencyAddButtons([]);
    setRulesTabledata([]);
    setIsEditClick(false);
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setShowAddRowbutton(false);
    setShowExecuteModal(false);
    setShowProcedureDataModal(false);
    setFields(defaultFields);
    setIsEditPermissionModalOpen(false);
    setIsPermissionModalOpen(false);
    setIsUserModalOpen(false);
    setIsRestrictionModalOpen(false);

  };

  const handleRole = () => {
    setRoleFieldClick(false);


  };


  //function to open confirmation when the delete button is clicked
  const openConfirm = (id) => {
    setDelId(id);
    setShowConfirmationModal(true);
  };


  const deleteRecord = async (id) => {

    setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
    setColumns(Array(fields.length).fill('')); // Assuming you have an initial state for `columns`



    const allColumns = fields.map((column) => column.column_name);
    setColumns(allColumns);
    const record_values = data.find((item) => item.id === id);

    const valuesWithoutId = record_values ? { ...record_values } : null;
    delete valuesWithoutId.id;

    axios.post(process.env.REACT_APP_API_URL + `api/delete_and_archive`, {
      database: selectedSchema,
      table: selectedTable,
      valueId: id,
      columns: allColumns,
      values: valuesWithoutId,
      isTableDependent: false,
      username: userName,
    })
      .then((response) => {
        if (response.status === 200) {
          setShowConfirmationModal(false);
          formatDates();
          console.log("Values", valuesWithoutId);
          toast.success("Record deleted successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });

        } else {
          toast.error("Error deleting Record", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        console.log("Columns", allColumns);
        console.log("Values", valuesWithoutId);
        toast.error("Error deleting Record", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      });




  };

  const editRecord = async (id) => {
    loadRelationDetails(selectedTable);

    setIsModalOpen(true);
    console.log("selected item id", id);
    setSelectedId(id);
    setRetrievedData(data.find((item) => item.id === id));
    console.log('new retrieved data', data.find((item) => item.id === id));
    const newOptions = [...relationshipOptionsList];
    setRelationshipOptionsList(newOptions);
    console.log("new options(edit)", newOptions);
    setShowsubmitButton(true);
    setSubmitButton('UPDATE');

  };

  const viewRecord = (id) => {
    console.log("view record button");
    setSelectedId(id);
    setRetrievedData(data.find((item) => item.id === id));
    setIsModalOpen(true);
    setShowsubmitButton(false);
  };

  const editTableRestrictions = (id, type, tableName, is_active) => {

    setRestrictionSubmitButton('UPDATE');

    const newis_active = is_active === '1' ? false : true;
    const editData = [];
    editData.push({ Tables: tableName, type: type, is_active: newis_active, id: id });

    const editValues = [];
    const selectedEditrestriction = editData.map((item) => ({
      ...editValues,
      [item.Tables]: {
        ...editValues[item.Tables],
        ['remove']: item.is_active, ['type']: item.type, ['id']: item.id
      },
    }));

    const isRemoved = is_active === '0' ? true : false;

    setCheckedState(isRemoved);

    setEditRestrictionTable(selectedEditrestriction);

    console.log("restriction id", id);
    console.log("table type", type);
    console.log("table name", tableName);
    console.log("active or not ", selectedEditrestriction);

    setIsEditTableRestrictionClicked(true);
    setIsRestrictionModalOpen(true);
  };

  const toggleCheckedState = () => {
    setCheckedState(!CheckedState);
  };

  const editRole = async (id, type) => {

    debugger;
    console.log("selected record", id);
    setSelectedPermissionId(id);
    SetIsEditPermissionClick(true);
    loadPermissionTable(id);




    try {
      if (type === "E") {
        setIsEditPermissionModalOpen(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getRolePermissionData/${selectedSchema}/${id}`);
        console.log("combined data", response.data);

        const filteredPermission = response.data.map((item) => {
          const { Rolename, Rolecode, ...rest } = item;
          return rest;

        });
        console.log('filtered role and permission',filteredPermission);
        setretrievedPermissionData(filteredPermission);

        console.log('permission data', filteredPermission);

        const filteredData = response.data[0];
        const retrievedRoleData = [
          { Rolename: filteredData.Rolename, Rolecode: filteredData.Rolecode }
        ];
        setretrievedRoleData(retrievedRoleData);
        console.log('role data', retrievedRoleData);
        setRetrivedRoleDatakeys(Object.keys(retrievedRoleData[0]));
        setRetrivedRoleDatavalues(Object.values(retrievedRoleData[0]));
        console.log("retrieved permission data", filteredPermission);

      } if (type === "C") {

        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getRolePermissionDataByRolename/${selectedSchema}/${id}`);
        console.log("combined data", response.data);

        const filteredPermission = response.data.map((item) => {
          const { Rolename, Rolecode, ...rest } = item;
          return rest;

        });
        console.log("filtered permission", filteredPermission);
        if (filteredPermission.length > 0) {
          setIsEditPermissionModalOpen(true);
          setIsPermissionModalOpen(false);
          console.log(filteredPermission);
          setretrievedPermissionData(filteredPermission);

          const filteredData = response.data[0];
          const retrievedRoleData = [
            { Rolename: filteredData.Rolename, Rolecode: filteredData.Rolecode }
          ];
          setretrievedRoleData(retrievedRoleData);
          console.log('role data', retrievedRoleData);
          setRetrivedRoleDatakeys(Object.keys(retrievedRoleData[0]));
          setRetrivedRoleDatavalues(Object.values(retrievedRoleData[0]));

          console.log("retrieved permission data", filteredPermission);
        } else {

        }

      }


    } catch (error) {
      console.log("the data is not received", error);
    }
  };



  const handleInputChange = (e, index, columnName, columnDataType) => {
    // used to empty the populated data in the edit modal
    setRetrievedData([]);

    const { value, checked, type } = e.target;
    const newValues = [...values];
    const newColumns = [...columns];

    // If it's a checkbox, set value to 1 if checked, 0 if unchecked
    const inputValue = columnDataType === 'checkbox' ? (checked ? 1 : 0) : value;

    newValues[index] = inputValue;

    if (columnDataType === 'file') {
      setIsFileIn(true);
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      setSelectedFile(file);
      // Append the file content or file name to newValues
      newValues[index] = file.name;
    }

    console.log(newValues);

    // If columnName is provided, update the corresponding column
    if (columnName) {
      newColumns[index] = columnName;
    }

    // Update the state with the new values
    setValues(newValues);
    setColumns(newColumns);

  };





  const handleSelectSchema = (event) => {
    const newselectedSchema = event.target.value;
    setIsSchemaSelected(true);
    setSelectedSchema(newselectedSchema);
    loadTables(newselectedSchema);
    loadNonRestrictedTables(newselectedSchema);
  };


  const handleExecuteInputChange = (e, index, data_type) => {
    const { value } = e.target;

    const updatedValues = [...executeInputValues];
    updatedValues[index] = { value, data_type };

    setExecuteInputValues(updatedValues);

  };

  const handleJobApplication = () => {
    setSelectedJobApplication(true);

  };

  const handleRelationScreen = () => {
    setIstableRestrictionClick(false);
    setShowExecuteButton(false);
    setShowIframe(false);
    setIsUsermanagementChosen(false);
    setIsPermissionTableChosen(false);
    setShowRelationScreen(true);
  }

  const handleTableRestrions = async () => {
    setShowIframe(false);
    setShowProcedureDataModal(false);
    setIstableRestrictionClick(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}api/getRestrictionTable`);
      console.log("table restriction data", response.data);
      setTableRestrictionData(response.data);
    } catch {
      console.log("error loading restriction table");

    }
  };

  const handleOpenExitJobModal = () => {
    setIsExitJobModalOpen(true);
  };

  const handleCloseExitJobModal = () => {
    setIsExitJobModalOpen(false);
  };


  const toggleTableDropdown = () => {
    setIsTableDropdownOpen(!isTableDropdownOpen);

  };

  const toggleOtherDropdown = (e) => {
    e.stopPropagation();
    setIsOtherDropdownOpen(!isOtherDropdownOpen);
  };

  const toggleUserDropdown = (e) => {
    e.stopPropagation();
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  const toggleExecuteDropdown = (e) => {
    e.stopPropagation();
    setIsExecuteDropdownOpen(!isExecuteDropdownOpen);

  };

  const toggleOtherTableDropdown = (e) => {
    e.stopPropagation();
    setIsOtherTableDropdownOpen(!isOtherTableDropdownOpen);

  };

  const toggleConfigDropdown = (e) => {
    e.stopPropagation();
    setIsConfigDropdownOpen(!isConfigDropdownOpen);
  };

  const toggleRelationDropdown = (e) => {
    e.stopPropagation();
    setIsRelationDropdownOpen(!isRelationDropdownOpen);
  }

  const toggleJobDropdown = (e) => {
    e.stopPropagation();
    setIsjobDropdownOpen(!isjobDropdownOpen);
  };

  const toggleExitJobDropdown = (e) => {
    e.stopPropagation();
    setIsExitJobDropdownOpen(!isExitJobDropdownOpen);
  };

  const toggleExecutewindow = async (selectedProcedure) => {
    setIsUsermanagementChosen(false);
    setIsPermissionTableChosen(false);
    setShowIframe(false);
    setShowRelationScreen(false);
    setIstableRestrictionClick(false);
    setShowExecuteButton(true);
    setProcedureName(selectedProcedure);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}api/CheckProcedureParameter/${selectedProcedure}`);
      console.log(response.data);
      setProcedureParameters(response.data);
      console.log('execute parameters', response.data);
    } catch {
      console.log("error");
    }
    setShowExecuteModal(true);
  };

  const toggleAccountDropdown = () => {
    setIsAccountDropDownOpen(!isAccountDropDownOpen);
  };

  const toggleIframe = (Link) => {
    console.log(Link);
    setSelectedLink(Link);
    console.log('selected link', Link);
    setShowIframe(true);
  };

  const executeStoredProcedure = async () => {
    console.log("parameters:", executeInputValues);
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + 'api/CallStoreProcedure', {
        params: {
          procedureName: procedureName,
          database: selectedSchema,
          parameters: executeInputValues
        },
      });

      console.log(response.data[0]);
      setStoredProcedureData(response.data[0]);
      setShowProcedureDataModal(true);
      setExecuteInputValues([]);
      setShowExecuteModal(false);
    } catch (error) {
      console.error(error);
      console.log("Error calling stored procedure");
    }
  };


  const handleLogOut = () => {
    localStorage.setItem('loggedIn', 'false');
    localStorage.removeItem('username');
    localStorage.removeItem('company');
    // Redirect the user to the desired page after login
    history.push('/login');
  };

  const handleJobSubmit = () => {
    console.log('job application');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sanitizedValues = values.map((value) => (value === '' ? null : value));
    setFormData(values);

    console.log("fields", fields);
    const newExtraFields = fields.map(item => item.column_name);
    console.log("new fields", newExtraFields);
    console.log("columns in handle submit", newColumns);

    if (submitButton === 'SUBMIT') {

      if (isFileIn) {
        try {

          const formData = new FormData();
          formData.append('database', selectedSchema);
          formData.append('table', selectedTable);
          formData.append('columns', JSON.stringify(columns)); // Convert columns array to JSON
          formData.append('values', JSON.stringify(sanitizedValues));
          formData.append('username', userName);
          formData.append('file', selectedFile);

          const response = await axios.post(`${process.env.REACT_APP_API_URL}api/insertData`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
          setColumns(Array(fields.length).fill('')); // Assuming you have an initial state for `columns`
          formatDates();
          handleCloseModal();

          toast.success(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } catch (error) {
          console.log(values);
          console.log(newExtraFields);
          console.log(columns);
          console.error(error);
          toast.error('Error occurred while sending data.', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      } else {
        try {

          const response = await axios.post(process.env.REACT_APP_API_URL + 'api/insertData', {
            database: selectedSchema,
            table: selectedTable,
            columns: columns,
            values: sanitizedValues, // Use the sanitized values array
            username: userName,
          });

          setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
          setColumns(Array(fields.length).fill('')); // Assuming you have an initial state for `columns`
          formatDates();
          handleCloseModal();

          toast.success(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } catch (error) {
          console.log(values);
          console.log(newExtraFields);
          console.log(columns);
          console.error(error);
          toast.error('Error occurred while sending data.', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      }

    } else {

      try {
        console.log("Columns", columns);
        const response = await axios.post(process.env.REACT_APP_API_URL + 'api/updateRecords', {
          database: selectedSchema,
          table: selectedTable,
          valueId: selectedId,
          columns: columns,
          values: sanitizedValues, // Use the sanitized values array
          username: userName,
        });


        setValues(Array(fields.length).fill('')); // Assuming you have an initial state for `values`
        (Array(fields.length).fill('')); // Assuming you have an initial state for `columns`
        formatDates();
        handleCloseModal();

        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } catch (error) {
        console.log(values);
        console.log(newExtraFields);
        console.log(columns);
        console.log(selectedId);
        console.error(error);
        toast.error('Error occurred while sending data.', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }

    }


  };
  useEffect(() => {

    // Update total pages when itemsPerPage or tableLength changes
    const totalPage1 = Math.ceil(tableLength / itemsPerPage);
    setTotalPages(totalPage1);
  }, [itemsPerPage, tableLength]);
  useEffect(() => {

    if (localStorage.getItem('loggedIn') === 'true') {
      if (!companyName) {
        history.push({
          pathname: '/Login'
        });
      }
    }
    if (!companyName) {
      history.push({
        pathname: '/Login'
      });
    }
    //loadFieldsJobApplication();

    if (!isSchemaSelected) {
      setSelectedSchema(companyName);
      loadExternalLinks(companyName);
      loadExecuteMenu(companyName);
      loadTables(companyName);
      loadNonRestrictedTables(companyName);
      loadRulesTable(companyName);
      loadViewRestrictionTable(companyName);
    } else {
      setIsSchemaSelected(false);
      loadTables(selectedSchema);
      loadNonRestrictedTables(selectedSchema);
      loadViewRestrictionTable(selectedSchema);
      loadRulesTable(companyName);
    }


    loadCompanyDetails(companyName);
    loadExternalLinks(companyName);
    //loadTableOthers(companyName);
    loadExecuteMenu(companyName);
    loadTables(companyName);
    loadDatabase();
    loadDatabaseSA();



    if (selectedTable) {
      formatDates();

    }

    if (roleCode === 'SA') {
      setIsSuperAdmin(true);
    } else {
      setIsSuperAdmin(false);

    }


    if (roleCode === 'AD') {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);

    }

    /* if (isEditclick) {
      loadDetailDependencydataForEdit();
    } */

  }, [selectedTable, selectedSchema, fields]);

  const mysqlToHtmlInputType = {
    INT: 'number',
    TINYINT: 'checkbox',
    SMALLINT: 'number',
    MEDIUMINT: 'number',
    BIGINT: 'number',
    DECIMAL: 'number',
    FLOAT: 'number',
    DOUBLE: 'number',
    DATE: 'date',
    TIME: 'time',
    DATETIME: 'datetime-local',
    TIMESTAMP: 'datetime-local',
    YEAR: 'number',
    CHAR: 'text',
    VARCHAR: 'text',
    TINYTEXT: 'text',
    TEXT: 'text',
    MEDIUMTEXT: 'text',
    LONGTEXT: 'text',
    ENUM: 'select',
    SET: 'select',
    TINYBLOB: 'file',
    BLOB: 'file',
    MEDIUMBLOB: 'file',
    LONGBLOB: 'file',
    BOOLEAN: 'checkbox',
  };

  return (
    <Container style={{ marginLeft: '0px', marginRight: '0px', marginBottom: '0px' }} fluid>
      <ToastContainer />

      <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => { deleteRecord(delId); }}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>


      {selectedSchema ? (
        <Row>
          {showSideBar && (
            <Col xs={12} md={2} style={{ backgroundColor: '#444f45', padding: '10px', paddingLeft: '0px', paddingRight: '0px', height: '100vh', overflowY: 'auto', overflowX: 'hidden' }} className="custom-sidebar">
              <div className='sidebar-content'>
                <FontAwesomeIcon icon={faXmark} size='2x' className='menu_icon' style={{ float: 'left', paddingLeft: '10px', color: '#fff' }} onClick={() => setShowSideBar(!showSideBar)} />
                <ul style={{ fontWeight: 'bolder' }}>

                  {hasTablePermissions && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className='second-dropdown' onClick={toggleTableDropdown}>
                          <span style={{ padding: '10px' }}>Tables</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff" }} />
                          {isTableDropdownOpen && (
                            <ListGroup onScroll={(e) => { e.stopPropagation(); }}>

                              <ListGroup onScroll={(e) => { e.stopPropagation(); }}>
                                {NewTables.map((item, index) => (
                                  item.type === 'T' && item.Tables !== 'user' && item.Tables !== 'role' && item.Tables !== 'permission' ? (
                                    <ListGroup.Item
                                      className='SideBar'
                                      key={index}
                                      active={item.Tables === selectedTable}
                                      //onClick={() => handleTableChange(item.Tables)}
                                      onClick={(e) => {
                                        handleTableChange(item.Tables);
                                        e.stopPropagation();
                                      }}
                                      style={{
                                        color: '#fff',
                                        height: '40px',
                                        border: 'none',
                                        backgroundColor: '#2C3B41',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                      title={item.haveId === 0 ? 'Id column required' : undefined}
                                    >
                                      {item.TableComment === '' ? item.Tables : item.TableComment}
                                    </ListGroup.Item>
                                  ) : null))}
                              </ListGroup>


                            </ListGroup>
                          )}
                        </li>
                      </div>
                    </Row>
                  )}


                  {(isSuperAdmin || isAdmin) && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className="second-dropdown" onClick={toggleUserDropdown}>
                          <span style={{ padding: '10px' }}>User</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff", }} />
                          {isUserDropdownOpen && (
                            <ListGroup onScroll={(e) => { e.stopPropagation(); }}>
                              {userTablesData.map((item, index) => (
                                <ListGroup.Item
                                  className='SideBar'
                                  key={index}
                                  action={item.haveId === 1} // Make it clickable only if haveId is 1
                                  active={item.Tables === selectedTable}
                                  onClick={(e) => {
                                    if (item.haveId === 1) {
                                      handleSelectUserManagement(item.Tables);
                                      e.stopPropagation(); // Prevent the event from propagating and closing the dropdown
                                    }
                                  }}
                                  style={{
                                    color: item.haveId === 1 ? '#fff' : 'red',
                                    height: '2rem',
                                    cursor: item.haveId === 1 ? 'pointer' : 'not-allowed', // Set cursor accordingly
                                    border: 'none',
                                    backgroundColor: '#2C3B41',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                  title={item.haveId === 0 ? 'Id column required' : undefined}
                                >
                                  {item.Tables}
                                </ListGroup.Item>
                              ))}

                              {permissionTableData.map((item, index) => (
                                <ListGroup.Item
                                  className='SideBar'
                                  key={index}
                                  action={item.haveId === 1} // Make it clickable only if haveId is 1
                                  active={item.Tables === selectedTable}
                                  onClick={(e) => {
                                    if (item.haveId === 1) {
                                      handleChoosePermission(item.Tables);
                                      e.stopPropagation(); // Prevent the event from propagating and closing the dropdown
                                    }
                                  }}
                                  style={{
                                    color: item.haveId === 1 ? '#fff' : 'red',
                                    height: '40px',
                                    cursor: item.haveId === 1 ? 'pointer' : 'not-allowed', // Set cursor accordingly
                                    border: 'none',
                                    backgroundColor: '#2C3B41',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                  title={item.haveId === 0 ? 'Id column required' : undefined}
                                >
                                  {item.Tables}
                                </ListGroup.Item>
                              ))}

                            </ListGroup>
                          )}
                        </li>
                      </div>
                    </Row>
                  )}

                  {hasExternalLinks && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className="second-dropdown" onClick={toggleOtherDropdown}>
                          <span style={{ padding: '10px' }}>External Links</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff", }} />
                          {isOtherDropdownOpen && (

                            <ListGroup onScroll={(e) => { e.stopPropagation(); }}>
                              {NewTables.map((item, index) => (
                                item.type === 'EL' ? (
                                  <ListGroup.Item
                                    className='SideBar'
                                    key={index}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const matchedLink = extLinks.find(linkItem => linkItem.menu === item.Tables);
                                      if (matchedLink) {
                                        toggleIframe(matchedLink.link);
                                      }
                                    }}
                                    style={{
                                      height: '40px',
                                      backgroundColor: '#2C3B41',
                                      color: '#fff',
                                      display: 'flex',
                                      border: 'none',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {item.Tables}
                                  </ListGroup.Item>
                                ) : null
                              ))}
                            </ListGroup>

                          )}
                        </li>
                      </div>
                    </Row>
                  )}

                  {hasStoredProcedure && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className="second-dropdown" onClick={toggleExecuteDropdown}>
                          <span style={{ padding: '10px' }}>Execute</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff" }} />
                          {isExecuteDropdownOpen && (
                            <ListGroup onScroll={(e) => { e.stopPropagation(); }}>
                              {NewTables.map((item, index) => (
                                item.type === 'E' ? (
                                  <ListGroup.Item
                                    className='SideBar'
                                    key={index}
                                    onClick={(e) => {
                                      toggleExecutewindow(item.Tables);
                                      e.stopPropagation();
                                    }}
                                    style={{
                                      height: '40px',
                                      backgroundColor: '#2C3B41',
                                      color: '#fff',
                                      display: 'flex',
                                      border: 'none',
                                      alignItems: 'center',
                                    }}

                                  >
                                    {item.Tables}
                                  </ListGroup.Item>
                                ) : null

                              ))}
                            </ListGroup>

                          )}
                        </li>
                      </div>
                    </Row>
                  )}

                  {hasOtherTables && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className="second-dropdown" onClick={toggleOtherTableDropdown}>
                          <span style={{ padding: '10px' }}>Other Tables</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff" }} />
                          {isOtherTableDropdownOpen && (
                            <ListGroup onScroll={(e) => { e.stopPropagation(); }}>
                              {NewTables.map((item, index) => (
                                item.type === 'OT' ? (
                                  <ListGroup.Item
                                    className='SideBar'
                                    key={index}

                                    onClick={(e) => {
                                      if (item.Require_newTab === 1) {
                                        if (item.Tables === 'job_application_form') {
                                          openInNewTab();
                                        } else {
                                          openInJobExitTab();
                                        }

                                      } else {
                                        handleTableChange(item.Tables);
                                      }
                                    }}
                                    style={{
                                      height: '40px',
                                      backgroundColor: '#2C3B41',
                                      color: '#fff',
                                      display: 'flex',
                                      border: 'none',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {item.Tables}
                                  </ListGroup.Item>
                                ) : null
                              ))}
                            </ListGroup>
                          )}
                        </li>
                      </div>
                    </Row>
                  )}




                  {isSuperAdmin && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className="second-dropdown" onClick={toggleConfigDropdown}>

                          <span style={{ padding: '10px' }}>Configuration</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff", }} />
                          {isConfigDropdownOpen && (
                            <ul className='inner_dropdown' style={{ marginTop: '0px' }} onClick={(e) => e.stopPropagation()}>
                              <li style={{ color: '#fff' }} onClick={handleTableRestrions}>Table Restrictions</li>
                            </ul>
                          )}
                        </li>

                      </div>
                    </Row>

                  )}

                  {isSuperAdmin && (
                    <Row>
                      <div className='hover_dropdown'>
                        <li className="second-dropdown" onClick={toggleRelationDropdown}>

                          <span style={{ padding: '10px' }}>Relation</span>
                          <FontAwesomeIcon className='downarrow' icon={faCaretDown} style={{ color: "#fff", }} />
                          {isRelationDropdownOpen && (
                            <ul className='inner_dropdown' style={{ marginTop: '0px' }} onClick={(e) => e.stopPropagation()}>
                              <li style={{ color: '#fff' }} onClick={handleRelationScreen}>Open Relation</li>
                            </ul>
                          )}
                        </li>

                      </div>
                    </Row>

                  )}

                  <Row style={{ position: 'absolute', bottom: '0', left: '0' }}>
                    <p style={{ fontSize: '0.8rem', color: '#fff' }}>© Copyright - Easy Outdesk. All rights reserved.</p>
                  </Row>

                </ul>
              </div>



            </Col>
          )}

          <Col xs={showSideBar ? 12 : 12} md={showSideBar ? 10 : 12} style={{ border: '5px solid #D5D5DD', backgroundColor: '#e6eee0', height: '100vh', paddingLeft: '0px', paddingRight: '0px' }}>
            {showIframe ? (

              <iframe
                title="Embedded Content"
                width="100%"
                height="100%"
                src={selectedLink}
                allowFullScreen
              ></iframe>
            ) : (
              <div style={{ overflowX: 'hidden', height: '99vh', marginBottom: '0px' }}>
                <Row>
                  <Col xs={12} md={12} style={{ position: 'relative', marginLeft: '0px', marginRight: '10px' }}>

                    <Row style={{ marginBottom: '0px', paddingLeft: '0px', paddingRight: '0px', textAlign: 'center', fontWeight: 'bolder', backgroundColor: '#93b874' }}>
                      <Col xs={2} md={2}>
                        {!showSideBar && (

                          <FontAwesomeIcon size='2x' icon={faBars} className='menu_icon' style={{ float: 'left', paddingTop: '10px', paddingLeft: '10px' }} onClick={() => setShowSideBar(!showSideBar)} />

                        )}
                      </Col>

                      <Col xs={8} md={7}>
                        <img src={`data:image/jpeg;base64, ${imgBlob}`} style={{ width: '58px', height: '58px' }} /> {companyName.replace(/(_PROD|_DEV|_UAT)$/, '').toUpperCase()}
                      </Col>

                      <Col xs={12} md={3}>
                        <label
                          onClick={toggleAccountDropdown}
                          style={{ float: 'right', paddingRight: '10px', marginTop: '10px' }}
                          className='user_name'
                        >
                          <FontAwesomeIcon icon={faUser} style={{ paddingRight: '5px' }} />{userName}
                        </label>
                        {isAccountDropDownOpen && (
                          <div className='account_dropdown' style={{ position: 'absolute', top: '100%', right: '0', zIndex: '1', backgroundColor: 'white', boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)' }}>
                            <ul style={{ paddingLeft: '10px' }}>
                              <li>
                                <Button
                                  className='loguout_button'
                                  style={{ backgroundColor: '#fff', paddingLeft: '0px', color: 'black', fontWeight: 'bold', fontSize: 'large' }}
                                  onClick={() => { handleLogOut(); }}
                                >
                                  <FontAwesomeIcon icon={faRightFromBracket} style={{ paddingRight: '10px' }} />Log out
                                </Button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </Col>


                    </Row>
                  </Col>

                </Row>

                {showRelationScreen && !showExecuteButton && !isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && !selectedJobApplication && (
                  <RelationShip_data />
                )}


                {!hasExternalLinks && !hasStoredProcedure && !hasTablePermissions && !hasOtherTables && (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
                    <Row>
                      <h4>Access Denied</h4>
                      <h6>Contact Admin for more details</h6>
                    </Row>
                  </div>

                )}

                {!showExecuteButton && selectedTable && !isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && !selectedJobApplication && !showRelationScreen && (
                  <Row style={{ backgroundColor: "#e6eee0", marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={8} md={3}>
                      <h6 style={{ paddingTop: '10px', textAlign: 'left', fontWeight: 'bold' }}>{selectedTable.toUpperCase().split('_').join(' ')}</h6>
                    </Col>
                    <Col xs={4} md={9} style={{ paddingTop: '10px' }}>
                      {showAddbutton && (
                        <Button
                          type="submit"
                          variant="warning"
                          style={{ height: '40px', float: 'right' }}
                          className="custom-button"
                          //onClick={handleAddButtonClick}
                          onClick={selectedTable === 'job_application_details' ? () => openInNewTab() : handleAddButtonClick}
                        >
                          + Add
                        </Button>
                      )}
                    </Col>
                  </Row>
                )}

                {isSuperAdmin && selectedSchema === 'control management' && !istableRestrictionClick && (
                  <Row style={{ backgroundColor: "#e6eee0", marginLeft: '0px', marginRight: '0px', paddingTop: '10px' }}>
                    <Col xs={4} md={4}>
                      <Form.Select onChange={(e) => handleSelectSchema(e)}>
                        <option>Select Schema</option>
                        {schemaList_SA.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.Database}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                )}

                {!showExecuteButton && !isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && !selectedJobApplication && !showRelationScreen && hasTablePermissions && (
                  <Row>
                    <Col xs={5} md={2} style={{ paddingRight: '0px' }}>
                      <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Form.Label className='select_entry' style={{ fontWeight: 'bold', marginRight: '10px' }}>Entry</Form.Label>
                        <Form.Control
                          as='select'
                          style={{ padding: 0, paddingLeft: 5, height: 35, marginBottom: 7, borderColor: '#93b874' }}
                          value={itemsPerPage}
                          placeholder='select entry'
                          onChange={handleEntriesPerPageChange}
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col xs={7} md={{ span: 6, offset: 4 }}>
                      <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Form.Label className='search' style={{ fontWeight: 'bold' }}>Search </Form.Label>
                        <Form.Control
                          className='search-form'
                          placeholder='search'
                          style={{ marginLeft: '5px', padding: 0, paddingLeft: 5, height: 35, marginTop: 0, marginBottom: 5, borderColor: '#93b874' }}
                          type='text'
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              handleSearch(e.target.value);
                            }
                          }}
                        >
                        </Form.Control>
                      </Form.Group>
                    </Col>

                  </Row>
                )}

                {!showExecuteButton && !isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && !selectedJobApplication && !showRelationScreen && hasTablePermissions &&(
                  <Row className='tablefixHead'>
                    <Table striped bordered hover variant="light" >
                      <thead>
                        <tr>
                          <th style={{ backgroundColor: '#93b874' }} className="text-center">No.</th>
                          {data?.length > 0 &&
                            Object.keys(data[0])?.map((key) => (
                              key.toLowerCase() === "id" || key.toLowerCase() === "signature" || key.toLowerCase() === "header_id" ? null : (
                                <th style={{ backgroundColor: '#93b874' }} onClick={() => sorting(key)} key={key} className="text-center">
                                  {key.split('_').join(' ')}{" "}
                                  {currentSortcolumn === key ? arrowButton : " "}
                                </th>
                              )
                            ))}
                          <th style={{ backgroundColor: '#93b874' }} className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 ? (
                          data.map((item, index) => (
                            <tr key={item.Id}>
                              <td className="text-center" scope="row">{(currentPage) * itemsPerPage + index + 1}</td>
                              {Object.keys(item).map((key) => (
                                key.toLowerCase() === "id" || key.toLowerCase() === "signature" || key.toLowerCase() === "header_id" ? null : (
                                  <td key={key}>{item[key]}</td>
                                )

                              ))}
                              <td className="text-center">

                                {showEditbutton && (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    //onClick={() => editRecord(item.id || item.ID)} // Pass the item.id to the delete function
                                    onClick={selectedTable === 'exit_job_form' ? () => openInJobExitTab(item.id || item.ID) : selectedTable === 'job_application_details' ? () => openInNewTab(item.id || item.ID) : () => editRecord(item.id || item.ID)}
                                  >Edit</button>

                                )}


                                {showDeletebutton && (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => openConfirm(item.id || item.ID)} // Pass the item.id to the delete function
                                  >
                                    Delete
                                  </button>
                                )}

                                {showViewbutton && (
                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() => viewRecord(item.id || item.ID)} // Pass the item.id to the delete function
                                  >
                                    View
                                  </button>

                                )}


                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={data.length > 0 ? Object.keys(data[0]).length + 2 : 2}>
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>

                  </Row>
                )}


                {selectedTable && !showExecuteButton && !isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && !selectedJobApplication && !showRelationScreen && (
                  <Row style={{ marginTop: '20px' }}>
                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label className='go_to_page' style={{ marginRight: 10, float: 'left' }}>Go to Page</Form.Label>
                        <Form.Control
                          type="text"
                          style={{ width: '50%', padding: '0', paddingLeft: 10, height: 35, borderColor: '#93b874' }}
                          value={goToPageInput}
                          placeholder='Enter page'
                          onChange={(e) => {
                            // Use regex to allow only numeric input
                            const numericValue = e.target.value.replace(/[^0-9]/g, '');
                            setGoToPageInput(numericValue);

                          }}
                          pattern="[0-9]*" // Enforce numeric input
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              formatDates(parseInt(e.target.value) - 1);
                              handleGoToPage();
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={{ span: 4, offset: 3 }}>
                      <div className='pagination-container'>
                        {totalPages > 1 && (
                          <ReactPaginate
                            pageCount={totalPages}
                            pageRangeDisplayed={5} // Adjust as needed
                            marginPagesDisplayed={2} // Adjust as needed
                            onPageChange={handlePageChange}
                            forcePage={currentPage}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                )}

                {showExecuteButton && !istableRestrictionClick && !isUsermanagementChosen && (
                  <Row>
                    {procedureParameters.map((item, index) => (
                      <Form.Group key={index} style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Col xs={6} md={4}>
                          <Form.Label style={{ fontWeight: 'bold' }}>
                            Enter {item.PARAMETER_NAME}
                          </Form.Label>
                        </Col>
                        <Col xs={12} md={8}>
                          <Form.Control
                            type={mysqlToHtmlInputType[item.DATA_TYPE.toUpperCase()]}
                            placeholder={'Enter' + item.PARAMETER_NAME}
                            onChange={(e) => handleExecuteInputChange(e, index, item.DATA_TYPE)}
                            style={{ height: '40px', flex: '2', display: item.column_name === 'header_id' ? 'none' : 'block' }}
                          />
                        </Col>

                      </Form.Group>
                    ))}
                  </Row>
                )}


                {isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && (
                  <Row justify="center" align="right" style={{ paddingBottom: '20px' }}>

                    <Col span={6}>
                      <Button style={{ width: '10%' }} onClick={handlePermissionAddButtonclick}>
                        Add Role
                      </Button>
                    </Col>
                  </Row>
                )}

                {istableRestrictionClick && (
                  <Row justify="center" align="right" style={{ paddingTop: '20px', paddingBottom: '20px' }}>

                    <Col span={6}>
                      <Button style={{ width: '10%' }} onClick={handleAddrestrictionButtonClick}>
                        Add Restrictions
                      </Button>
                    </Col>
                  </Row>
                )}

                {!isPermissionTableChosen && !istableRestrictionClick && isUsermanagementChosen && (
                  <Row justify="center" align="right" style={{ paddingBottom: '20px' }}>

                    <Col span={6}>
                      <Button style={{ width: '10%' }} onClick={handleUserAddButtonclick}>
                        Add User
                      </Button>
                    </Col>
                  </Row>
                )}

                {/* user management table */}
                {isUsermanagementChosen && !isPermissionTableChosen && !istableRestrictionClick && (
                  <Row className='tablefixHead'>
                    {userData?.length > 0 ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            {Object.keys(userData[0])?.map((key) => (
                              key.toLowerCase() === "id" ? null : (
                                <th style={{ backgroundColor: '#93b874' }} key={key} className="text-center">
                                  {key}{" "}
                                </th>
                              )
                            ))}
                            <th style={{ backgroundColor: '#93b874' }} className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userData?.map((row, index) => (
                            <tr key={index}>
                              {Object.keys(row)?.map((key) => (
                                key.toLowerCase() === "id" ? null : (
                                  <td key={key} className="text-center">
                                    {row[key]}
                                  </td>
                                )
                              ))}
                              <td className="text-center">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => editUser(row.id)} // Pass the item.id to the delete function
                                >Edit</button>

                                <button
                                  className="btn btn-info btn-sm"
                                //onClick={() => viewRecord(item.id || item.ID)} // Pass the item.id to the delete function
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No data available</p>
                    )}
                  </Row>
                )}

                {/* role and permission table */}
                {isPermissionTableChosen && !isUsermanagementChosen && !istableRestrictionClick && (
                  <Row className='tablefixHead'>
                    {roleData?.length > 0 ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            {Object.keys(roleData[0])?.map((key) => (
                              key.toLowerCase() === "id" ? null : (
                                <th style={{ backgroundColor: '#93b874' }} key={key} className="text-center">
                                  {key}{" "}
                                </th>
                              )
                            ))}
                            <th style={{ backgroundColor: '#93b874' }} className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {roleData?.map((row, index) => (
                            <tr key={index}>
                              {Object.keys(row)?.map((key) => (
                                key.toLowerCase() === "id" ? null : (
                                  <td key={key} className="text-center">
                                    {row[key]}
                                  </td>
                                )
                              ))}
                              <td className="text-center">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => editRole(row.id, "E")} // Pass the item.id to the delete function
                                >Edit</button>

                                <button
                                  className="btn btn-info btn-sm"
                                //onClick={() => viewRecord(item.id || item.ID)} // Pass the item.id to the delete function
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No data available</p>
                    )}
                  </Row>
                )}

                {/* Role and permission modal */}
                <Modal className='Add_modal' show={isPermissionModalOpen} onHide={handleCloseModal} style={{ padding: '10px' }}>

                  <Modal.Header>
                    <h2 style={{ textAlign: 'center', paddingTop: '10px' }}>Role Permission</h2>
                  </Modal.Header>

                  <div style={{ padding: '30px' }}>
                    <Modal.Body>
                      <Form>

                        <Form.Group>
                          <Form.Label>Rolename</Form.Label>
                          <Form.Control
                            type="text"
                            autoFocus
                            onBlur={(e) => handleAddRolechange("Rolename", e.target.value)}

                          />
                        </Form.Group>

                        <Form.Group style={{ paddingBottom: '20px' }}>
                          <Form.Label>Rolecode</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={(e) => handleAddRolechange("Rolecode", e.target.value)}

                          />
                        </Form.Group>



                        <table className="table table-striped table-bordered">
                          <thead style={{ textAlign: 'center' }}>
                            <th>Object</th>
                            <th>Read</th>
                            <th>Create</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </thead>
                          <tbody style={{ textAlign: 'center' }}>
                            {tablesType.map((item, index) => (
                              <tr>
                                <td ><Form.Label style={{ fontWeight: 'bold', marginRight: '10px', flex: '1' }} >{item.Tables.toUpperCase()}</Form.Label></td>
                                {['Read', 'Create', 'update', 'Delete'].map((operation) => (
                                  <td>
                                    <Form.Check
                                      type={'checkbox'}
                                      id={operation}
                                      label={operation}
                                      onChange={() => handleCheckboxChange(item.Tables, operation.toLowerCase())}

                                    />
                                  </td>

                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>


                      </Form>



                    </Modal.Body>
                  </div>

                  <Modal.Footer style={{ justifyContent: 'center' }}>
                    <Button onClick={handleAddPermissionSubmit}>Submit</Button>
                  </Modal.Footer>


                </Modal>

                {/* Edit role permission modal */}

                <Modal className='Add_modal' show={isEditPermissionModalOpen} onHide={handleCloseModal} style={{ padding: '10px' }}>

                  <Modal.Header>
                    <h2 style={{ textAlign: 'center', paddingTop: '10px' }}>Edit Role Permission</h2>
                  </Modal.Header>

                  <div style={{ padding: '30px' }}>
                    <Modal.Body>
                      {retrievedRoleData.map((item, index) => (
                        <Form>

                          <Form.Group>
                            <Form.Label>Rolename</Form.Label>
                            <Form.Control
                              type="text"
                              autoFocus
                              value={item.Rolename || ''}
                              onChange={(e) => handleEditRolechange("Rolename", index, e.target.value)}

                            />
                          </Form.Group>

                          <Form.Group style={{ paddingBottom: '20px' }}>
                            <Form.Label>Rolecode</Form.Label>
                            <Form.Control
                              type="text"
                              value={item.Rolecode || ''}
                              onChange={(e) => handleEditRolechange("Rolecode", index, e.target.value)}

                            />
                          </Form.Group>


                          <table className="table table-striped table-bordered">
                            <thead style={{ textAlign: 'center' }}>
                              <th>Object</th>
                              <th>Read</th>
                              <th>Create</th>
                              <th>Edit</th>
                              <th>Delete</th>
                            </thead>

                            <tbody style={{ textAlign: 'center' }}>
                              {tableForPermission.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <Form.Label style={{ fontWeight: 'bold', marginRight: '10px', flex: '1' }}>
                                      {item.Tables.toUpperCase()}
                                    </Form.Label>
                                  </td>
                                  {['read', 'create', 'update', 'delete'].map((operation) => (
                                    <td key={operation}>
                                      <Form.Check
                                        type={'checkbox'}
                                        id={`${item.Tables}_${operation}`}
                                        label={operation.charAt(0).toUpperCase() + operation.slice(1)}
                                        checked={
                                          retrievedPermissionData.some((tab) => tab.table === item.Tables) &&
                                          retrievedPermissionData.find((tab) => tab.table === item.Tables)[operation] === 1
                                        }
                                        onChange={() => handleEditPermissionCheckboxChange(item.Tables, operation)}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>

                          </table>

                        </Form>

                      ))}


                    </Modal.Body>
                  </div>

                  <Modal.Footer style={{ justifyContent: 'center' }}>
                    <Button onClick={handleAddPermissionSubmit}>Update</Button>
                  </Modal.Footer>


                </Modal>

                {/* Add user management modal */}
                <Modal className='Add_modal' show={isUserModalOpen} onHide={handleCloseModal} style={{ padding: '10px' }}>

                  <Modal.Header>
                    <h2 style={{ textAlign: 'center', paddingTop: '10px' }}>Add User</h2>
                  </Modal.Header>

                  <div style={{ padding: '30px' }}>
                    <Modal.Body>
                      <Form>

                        <Form.Group>
                          <Form.Label>Username</Form.Label>
                          <Form.Control
                            type="text"
                            value={isEditUserclick ? userEditData.username || '' : userInput.username || ''}
                            onChange={(e) => handleUserInput("username", e.target.value)}
                          />
                        </Form.Group>

                        <Form.Group style={{ paddingBottom: '20px' }}>
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="text"
                            value={isEditUserclick ? userEditData.email || '' : userInput.email || ''}
                            onChange={(e) => handleUserInput("email", e.target.value)}

                          />
                        </Form.Group>

                        {!isEditUserclick && (
                          <Form.Group style={{ paddingBottom: '20px' }}>
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                              type="password"
                              onChange={(e) => handleUserInput("password", e.target.value)}

                            />
                          </Form.Group>
                        )}

                        {!isEditUserclick && (
                          <Form.Group style={{ paddingBottom: '20px' }}>
                            <Form.Label>Confirm Password</Form.Label>
                            <Form.Control
                              type="password"
                              onChange={(e) => handleUserInput("confirmpassword", e.target.value)}
                            />
                            <p className="error-message" style={{ color: 'red' }}>{passError.confirmPassword}</p>
                          </Form.Group>
                        )}


                        <Form.Group style={{ paddingBottom: '20px' }}>
                          <Form.Label>Contact no</Form.Label>
                          <Form.Control
                            type="text"
                            value={isEditUserclick ? userEditData.contact_no || '' : userInput.contact_no || ''}
                            onChange={(e) => handleUserInput("contact_no", e.target.value)}
                          />
                        </Form.Group>

                        <Form.Group style={{ paddingBottom: '20px' }}>
                          <Form.Label>Role</Form.Label>
                          <Form.Select
                            onChange={(e) => handleUserInput("Rolename", e.target.value)}
                            value={(isEditUserclick && userEditData.Rolename) ? userEditData.Rolename : userInput.Rolename}
                          >
                            <option value='' disabled>Select Role</option>
                            {roleData.map((item) => (
                              <option key={item.id} value={item.Rolename}>
                                {item.Rolename}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>



                      </Form>



                    </Modal.Body>
                  </div>

                  <Modal.Footer style={{ justifyContent: 'center' }}>
                    <Button onClick={handleUserSubmit}>Submit</Button>
                  </Modal.Footer>


                </Modal>


                {/* Add restriction modal */}
                <Modal className='Add_modal' show={isRestrictionModalOpen} onHide={handleCloseModal} style={{ padding: '10px' }}>
                  <Modal.Header>
                    <h2 style={{ textAlign: 'center', paddingTop: '10px' }}>Add Restrictions</h2>
                  </Modal.Header>
                  <div style={{ padding: '30px' }}>
                    <Modal.Body>
                      {isEditTableRestrictionClicked ? (
                        <>
                          <h2>Edit Restriction</h2>
                          {/* Your edit mode JSX here */}
                          {editRestrictionTable.map((table, index) => {
                            const tableName = Object.keys(table)[0];
                            const insertedData = viewRestrictionTables.find(data => data.tables === tableName);
                            const isRemoved = insertedData ? insertedData.is_active === '0' : false;

                            return (
                              <Form.Group key={index}>
                                <Form.Label style={{ fontWeight: 'bold', marginRight: '10px', flex: '1' }}>
                                  {tableName.toUpperCase()}
                                </Form.Label>
                                {['remove'].map((operation) => (
                                  <Form.Check
                                    key={operation}
                                    type={'checkbox'}
                                    id={operation}
                                    label={operation}
                                    checked={CheckedState}
                                    onChange={() => {
                                      toggleCheckedState();
                                      handleEditRestrictionCheckboxChange(index, tableName, table, CheckedState);
                                    }}
                                  />
                                ))}
                              </Form.Group>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <h2>Add Restrictions</h2>

                          {/* <thead style={{ textAlign: 'center' }}>
                            <th>Tables</th>
                            <th>Restriction</th>
                            
                          </thead>
                          <tbody style={{ textAlign: 'center' }}>
                            {dataForRestrictioncondition.map((table, index) => (
                              <tr>
                                <td ><Form.Label style={{ fontWeight: 'bold', marginRight: '10px', flex: '1' }} >{table.tableName.toUpperCase()}</Form.Label></td>
                                {['read', 'create', 'update', 'delete'].map((operation) => (
                                  <td key={operation}>
                                    <Form.Check
                                      type={'checkbox'}
                                      id={`${item.table}_${operation}`}
                                      label={operation.charAt(0).toUpperCase() + operation.slice(1)}
                                      checked={item[operation] === 1}
                                      onChange={() => handleEditPermissionCheckboxChange(item.table, operation)}
                                    />
                                  </td>
                                ))}

                              </tr>
                            ))}
                          </tbody> */}


                          <Row style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <Col xs={4} md={4}>
                              <Form.Select onChange={(e) => handleSelectSchema(e)} value={selectedSchema}>
                                <option>Select Schema</option>
                                {schemaList_SA.map((item) => (
                                  <option key={item.value} value={item.value}>
                                    {item.Database}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col>
                          </Row>
                          {dataForRestrictioncondition.map((table, index) => {
                            const tableName = Object.keys(table)[0];
                            return (
                              <Form.Group key={index}>
                                <Form.Label style={{ fontWeight: 'bold', marginRight: '10px', flex: '1' }}>
                                  {tableName.toUpperCase()}
                                </Form.Label>
                                {['remove'].map((operation) => (
                                  <Form.Check
                                    key={operation}
                                    type={'checkbox'}
                                    id={operation}
                                    label={operation}
                                    // checked={table[tableName].remove}
                                    onChange={() => handleRestrictionCheckboxChange(index, tableName)}
                                  />
                                ))}
                              </Form.Group>
                            );
                          })}
                        </>
                      )}
                    </Modal.Body>
                  </div>
                  <Modal.Footer style={{ justifyContent: 'center' }}>
                    <Button onClick={handleAddRestrictionSubmit}>{restrictionSubmitButton}</Button>
                  </Modal.Footer>
                </Modal>

                {selectedJobApplication && !isPermissionTableChosen && !istableRestrictionClick && !isUsermanagementChosen && (
                  <Row justify="center" align="right" style={{ paddingBottom: '20px' }}>

                    <Col span={6}>
                      <Button style={{ width: '10%' }} onClick={() => openInNewTab('http://localhost:3000/jobApplication')}>
                        Add Applicant
                      </Button>
                    </Col>
                  </Row>
                )}

                {/* job application table */}
                {selectedJobApplication && !isUsermanagementChosen && !isPermissionTableChosen && !istableRestrictionClick && (
                  <Row className='tablefixHead'>
                    {jobFields?.length > 0 ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            {Object.keys(jobFields[0])?.map((key) => (
                              key.toLowerCase() === "id" ? null : (
                                <th style={{ backgroundColor: '#93b874' }} key={key} className="text-center">
                                  {key}{" "}
                                </th>
                              )
                            ))}
                            <th style={{ backgroundColor: '#93b874' }} className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {jobFields?.map((row, index) => (
                            <tr key={index}>
                              {Object.keys(row)?.map((key) => (
                                key.toLowerCase() === "id" ? null : (
                                  <td key={key} className="text-center">
                                    {row[key]}
                                  </td>
                                )
                              ))}
                              <td className="text-center">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => openInNewTab('http://localhost:3000/jobApplication', row.id)}
                                >
                                  Edit
                                </button>


                                <button
                                  className="btn btn-info btn-sm"
                                //onClick={() => viewRecord(item.id || item.ID)} // Pass the item.id to the delete function
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No data available</p>
                    )}
                  </Row>
                )}



                {showExecuteButton && !istableRestrictionClick && !isUsermanagementChosen && (
                  <Row justify="center" align="middle" style={{ paddingTop: '20px' }}>
                    <Col span={4}>
                      <Button style={{ width: '10%' }} onClick={executeStoredProcedure}>
                        Execute
                      </Button>
                    </Col>
                  </Row>
                )}


                {showProcedureDataModal && !istableRestrictionClick && (
                  <Row className='tablefixHead'>
                    {storedProcedureData?.length > 0 ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            {Object.keys(storedProcedureData[0])?.map((key) => (
                              key.toLowerCase() === "id" ? null : (
                                <th style={{ backgroundColor: '#93b874' }} key={key} className="text-center">
                                  {key}{" "}
                                </th>
                              )
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {storedProcedureData?.map((row, index) => (
                            <tr key={index}>
                              {Object.keys(row)?.map((key) => (
                                key.toLowerCase() === "id" ? null : (
                                  <td key={key} className="text-center">
                                    {row[key]}
                                  </td>
                                )
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No data available</p>
                    )}
                  </Row>
                )}


                {/* view restriction table */}
                {istableRestrictionClick && (
                  <Row className='tablefixHead'>
                    {tableRestrictionData?.length > 0 ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            {Object.keys(tableRestrictionData[0])?.map((key) => (
                              key.toLowerCase() === "id" ? null : (
                                <th style={{ backgroundColor: '#93b874' }} key={key} className="text-center">
                                  {key}{" "}
                                </th>
                              )
                            ))}
                            <th style={{ backgroundColor: '#93b874' }} className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableRestrictionData?.map((row, index) => (
                            <tr key={index}>
                              {Object.keys(row)?.map((key) => (
                                key.toLowerCase() === "id" ? null : (
                                  <td key={key} className="text-center">
                                    {row[key]}
                                  </td>
                                )
                              ))}
                              <td className="text-center">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => editTableRestrictions(row.id, row.type, row.tables, row.is_active)} // Pass the item.id to the delete function
                                >Edit</button>

                                <button
                                  className="btn btn-info btn-sm"
                                //onClick={() => viewRecord(item.id || item.ID)} // Pass the item.id to the delete function
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No data available</p>
                    )}
                  </Row>
                )}


                {/* <div style={{ position: 'fixed', bottom: '0', left: '0', width: '100%', textAlign: 'center', backgroundColor: '#93b874' }}>
                    <p style={{ fontSize: '0.8rem', color: '#fff' }}>© Copyright - Easy Outdesk. All rights reserved.</p>
                  </div> */}

              </div>
            )}


          </Col>


        </Row>
      ) : null}



      {selectedTable ? (
        <Modal className='Add_modal' show={isModalOpen} onHide={handleCloseModal} style={{ padding: '10px' }}>
          <h2 style={{ textAlign: 'center', paddingTop: '10px' }}>{tableComment === "" ? selectedTable.toUpperCase().split('_').join(' ') : tableComment.toUpperCase().split('_').join(' ')}</h2>
          <div className='add_modal' style={{ padding: '30px' }}>
            <Form onSubmit={handleSubmit}>
              {fields.map((item, index) => (
                <Form.Group key={index} style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                  {item.column_name === 'header_id' ? null : (
                    <Form.Label style={{ fontWeight: 'bold', marginRight: '10px', flex: '1' }}>
                      {item.COLUMN_COMMENT === '' ? item.column_name.toUpperCase().split('_').join(' ') : item.COLUMN_COMMENT.toUpperCase().split('_').join(' ')}
                    </Form.Label>
                  )}

                  {item.column_name === 'header_id' ? null : relationshipOptionsList.some((opt) => opt.column === item.column_name) ? (
                    <Form.Select
                      as="select"
                      custom
                      value={retrievedData[item.column_name]}
                      // value={selectedDropdownValue} // Ensure you set the selected value in the state
                      onChange={(e) => handleInputChange(e, index, item.column_name)} // Handle the select change
                      style={{ height: '40px', flex: '2', marginLeft: 10 }}
                    >
                      <option value="">{'Select ' + item.column_name}</option>
                      {/* Render options based on your primary table data */}
                      {(relationshipOptionsList.find((opt) => opt.column === item.column_name)?.options ?? []).map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.text}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    // Form.Check or Form.Control based on datatype
                    mysqlToHtmlInputType[item.data_type.toUpperCase()] === 'checkbox' ? (
                      <Form.Check
                        type="checkbox"
                        label={`Check ${item.column_name}`}
                        checked={retrievedData[item.column_name]}
                        onChange={(e) => handleInputChange(e, index, item.column_name, 'checkbox')}
                        style={{ flex: '2' }}
                      />
                    ) : (
                      <Form.Control
                        type={isRulesMatch && item.column_name === ruleTableMatch.column_name ? ruleTableMatch.tbl_type : mysqlToHtmlInputType[item.data_type.toUpperCase()] || 'text'}
                        value={retrievedData[item.column_name]}
                        onChange={(e) => handleInputChange(e, index, item.column_name, item.data_type)}
                        placeholder={`Enter ${item.column_name.split('_').join(' ')}`}
                        style={{ height: '40px', flex: '2' }}
                      />
                    )
                  )}

                </Form.Group>

              ))}

              {showsubmitButton && (
                <Button
                  type="submit"
                  variant="primary"
                  style={{ width: '40%', height: '40px', marginLeft: '30%', marginBottom: '0px', marginTop: '30px' }}
                  className="custom-button"
                >
                  {submitButton}
                </Button>
              )}

            </Form>
          </div>

        </Modal>
      ) : null}

      <Modal show={isExitJobModalOpen} onHide={handleCloseExitJobModal} backdrop="static" keyboard={false} style={{ maxWidth: '100%', margin: 0 }}>
        <Modal.Header closeButton>
          <Modal.Title>EXIT INTERVIEW FORM</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <h5 style={{ textAlign: 'center' }}>EMPLOYEE EXIT INTERVIEW</h5>
          <div>
            <h6>Purpose</h6>
            <p>The intent of this Exit Interview is to ensure that any employee is informed of his/her rights,
              benefits, and the records are collected and maintained regarding the termination of employment.
            </p>
          </div>

          <div>
            <h6>Policy</h6>
            <p>
              It is the policy of Acme Global Company to ensure that any employee whose employment is being terminated, whether voluntary or involuntarily, receives an exit interview.
              The exit interview shall be conducted by Sharon Williams and/ or Natalia Winfree. The objectives of the exit interview are as follows:
            </p>
          </div>

          <div>
            <ul>
              <li>To determine and discuss the employee’s reason for resignation, if applicable.</li>
              <li>To discover and discuss any misunderstandings the employee may have had about his/her job or with his/her manager.</li>
              <li>To maintain good will and teamwork amongst current and future employees.</li>
              <li>To review administrative details with the employee such as benefit continuation rights and conversion privileges,
                if any, final pay, re-employment policy, and employment compensation.</li>
              <li>To review administrative details with the employee such as benefit continuation rights and conversion privileges,
                if any, final pay, re-employment policy, and employment compensation.</li>
            </ul>
          </div>

          <div>
            <h6>Procedure</h6>
            <p>Upon an employee’s announcement of his/her intent to resign, the project director or manager shall schedule an exit interview for the employee with Sharon Williams or Natalia Winfree as soon as possible.</p>

            <p> In the event that a decision has been made to terminate an employee, the employee shall meet with Sharon Williams or Natalia Winfree for an exit interview as soon as possible, or as deemed appropriate.</p>

            <p> Throughout the duration of the exit interview, Sharon Williams or Natalia Winfree shall seek to meet all objectives listed within the exit interview policy.</p>

            <p>The departing employee shall complete the following exit interview form as thoroughly as possible.</p>

            <p> Any information obtained during the exit interview may be disclosed to and/or discussed with the employee manager, the project Director and Partners, as deemed necessary, in order to investigate any allegations made or to inform them of any emerging problems.</p>
          </div>

          <div>
            <h5>REMINDERS</h5>
            <p>Please remember that your work with Acme Global Company was completed under a non-disclousure agreement. We highly value client confidentiality and all terms of the agreement. Feel free to request a copy for your reference if you do not already have one.</p>
            <p>All Acme Global Company equipment must be returned to the main office in order to received final payment.</p>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseExitJobModal} >
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer>
      </Modal>



    </Container >
  );
};

export default DynamicScreen;
